<ng-container rtBlock="sc-language-switcher">
    <nav rtElem="nav" aria-label="Language" i18n-aria-label="@@navLanguageLabel">
        <a
            rtElem="link"
            hreflang="ru"
            qa-dataid="language-switcher-ru"
            [href]="ruHref()"
            [rtMod]="{ active: isRu() }"
            [attr.aria-current]="isRu() ? 'page' : null"
            (click)="onSelect($event, 'ru')">
            RU
        </a>
        <a
            rtElem="link"
            hreflang="en"
            qa-dataid="language-switcher-en"
            [href]="enHref()"
            [rtMod]="{ active: isEn() }"
            [attr.aria-current]="isEn() ? 'page' : null"
            (click)="onSelect($event, 'en')">
            EN
        </a>
    </nav>
</ng-container>
